var WARNING_MESSAGE = /* @__PURE__ */ ((WARNING_MESSAGE2) => {
  WARNING_MESSAGE2["UNMUTE_LOCAL_MIC_FAIL_MUTE_ALL"] = "Has been fully muted and cannot open the microphone";
  WARNING_MESSAGE2["UNMUTE_LOCAL_MIC_FAIL_MUTE_BY_MASTER"] = "Has been muted by the host and cannot open the microphone";
  WARNING_MESSAGE2["UNMUTE_LOCAL_MIC_FAIL_AUDIENCE"] = "To apply to speak in the room, please raise your hand first to apply for the microphone";
  WARNING_MESSAGE2["UNMUTE_LOCAL_CAMERA_FAIL_MUTE_ALL"] = "Has been full static painting, can not open the video";
  WARNING_MESSAGE2["UNMUTE_LOCAL_CAMERA_FAIL_MUTE_BY_MASTER"] = "It has been stilled by the host and cannot open the video";
  WARNING_MESSAGE2["UNMUTE_LOCAL_CAMERA_FAIL_AUDIENCE"] = "To apply to speak in the room, please raise your hand first to apply for the microphone";
  return WARNING_MESSAGE2;
})(WARNING_MESSAGE || {});
var MESSAGE_DURATION = /* @__PURE__ */ ((MESSAGE_DURATION2) => {
  MESSAGE_DURATION2[MESSAGE_DURATION2["NORMAL"] = 3e3] = "NORMAL";
  MESSAGE_DURATION2[MESSAGE_DURATION2["LONG"] = 5e3] = "LONG";
  return MESSAGE_DURATION2;
})(MESSAGE_DURATION || {});
export {
  MESSAGE_DURATION,
  WARNING_MESSAGE
};
